import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import GetAnnouncementResponse from '../interfaces/announcement/GetAnnouncementResponse';
import AddOrUpdateAnnouncementPayload from '../interfaces/announcement/AddOrUpdateAnnouncementPayload';
import AddOrUpdateAnnouncementResponse from '../interfaces/announcement/AddOrUpdateAnnouncementResponse';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {
  public requestAPIurl: any = environment.apiURL;
  userId: any;
  headers: any;

  constructor(private http: HttpClient) { }

  setHeaders() {
    if (JSON.parse(sessionStorage.getItem('logged-in-user'))) {
      this.userId = JSON.parse(sessionStorage.getItem('logged-in-user'))._id;
      this.headers = new HttpHeaders().set('id', this.userId);
    }
  }

  public getAnnouncements(): Observable<GetAnnouncementResponse> {
    let getAnnouncementEndpointURL = `${this.requestAPIurl}/api/announcement`;
    return this.http.get<GetAnnouncementResponse>(getAnnouncementEndpointURL);
  }

  public updateAnnouncement(announcementId: string, payload: AddOrUpdateAnnouncementPayload): Observable<AddOrUpdateAnnouncementResponse> {
    this.setHeaders();
    let updateAnnouncementEndpointURL = `${this.requestAPIurl}/api/announcement/${announcementId}`;
    return this.http.put<AddOrUpdateAnnouncementResponse>(updateAnnouncementEndpointURL, payload, { headers: this.headers });
  }

  public addAnouncement(payload: AddOrUpdateAnnouncementPayload): Observable<AddOrUpdateAnnouncementResponse> {
    let addAnnouncementEndpointURL = `${this.requestAPIurl}/api/announcement`;
    this.setHeaders();
    return this.http.post<AddOrUpdateAnnouncementResponse>(addAnnouncementEndpointURL, payload, { headers: this.headers });
  }
}
